export const sizes = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

const generateQueries = (query, sizes) => Object.keys(sizes).reduce((acc, label) => {
    return {
        ...acc,
        [label]: `@media (${query}: ${sizes[label]}px)`,
    }
}, {});

export const minWidth = generateQueries('min-width', sizes);
export const maxWidth = generateQueries('max-width', sizes);
